import { ActionEditField, InvoiceSellerAction, InvoiceSellerState } from '../view/InvoiceSeller';

export function invoiceSellerReducer(
    state: InvoiceSellerState,
    action: InvoiceSellerAction
): InvoiceSellerState {
    switch (action.type) {
        case 'TOGGLE_EDIT':
            return {
                ...state,
                [action.field]: !state[action.field],
                email: action.email ? action.email : state.email,
                reference: action.reference ? action.reference : state.reference
            };
        default:
            return state;
    }
}

export function createReferenceAction(value: string): InvoiceSellerAction {
    return { type: 'TOGGLE_EDIT', field: ActionEditField.Reference, reference: value };
}

export function createEmailAction(value: string): InvoiceSellerAction {
    return { type: 'TOGGLE_EDIT', field: ActionEditField.Email, email: value };
}
